export default "/images/silent-hill-trauma.png";